import {useSelector} from "react-redux";
import store from "src/storeWire";
import { getBomList,setBomList,setMessage } from "src/store/slice/model/Admin/AdminBOM";


export function useAdminBOMStore() {
  const bomList = useSelector((state) => state.entities.model_Admin_BOMs_list.bomList)
  const message = useSelector((state) => state.entities.model_Admin_BOMs_list.message)

  let data = {
    bomList,
    message
  };

  let fetch = {
   
    get_bom_list: async (bomId) => {
      return await store.dispatch(getBomList(bomId))
    },
   
  };
  let set = {
    set_bom_list: async (params) => {
      return await store.dispatch(setBomList(params))
    },
    set_message:(params)=>{
      return store.dispatch(setMessage(params))
    }
  };
  return [data, fetch, set]
}